module.exports = __webpack_public_path__ + "static/hyperv_53.d75af642.png";